import { BaseClass } from "./decision.model";

export class OptionVariable extends BaseClass {
    text: string;
    optionId: number;
    displayOrder: number;
  }